module.exports = __webpack_public_path__ + "img/partner_novexx.033345d1.jpeg";